<template>
  <header class="header header-sticky-home will-animation inFocus">
    <div class="container">
      <div class="header-inner">
        <div class="header__col">
          <div class="logo-text">Razum<span class="logo-text-pink">V</span>Dom</div>
          <nav class="main-nav">
            <router-link to="/" :class="{'main-nav__item':true,'main-nav__item_active':$route.name==='main'}">Что такое умный дом?</router-link>
            <router-link to="/solutions" :class="{'main-nav__item':true,'main-nav__item_active':$route.name==='solutions'}">Решения</router-link>
            <router-link to="/faq" :class="{'main-nav__item':true,'main-nav__item_active':$route.name==='faq'}">Частые вопросы</router-link>
            <a href="#" class="main-nav__item" @click="popupOrderShow">Заказать</a>
          </nav>
        </div>
        <a href="tel:89959970558" class="header__phone">8(995)-997-05-58</a>
        <a href="/DomovoyPresentation.pdf" type="application/octet-stream" download="Домовой презентация.pdf">Скачать презентацию</a>
      </div>
    </div>
    <div class="header-inner mob">
      <div class="header__col">
        <div class="logo-text">Razum<span class="logo-text-pink">V</span>Dom</div>
      </div>
      <a @click="menuOpen" class="burger js-menu">
        <div class="menu__figure">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" class="menu__basket-icon">
            <title>menu</title>
            <rect class="a" y="2" width="18" height="2"></rect>
            <rect class="a" y="9" width="18" height="2"></rect>
            <rect class="a" y="16" width="18" height="2"></rect>
          </svg>
        </div>
      </a>
    </div>
    <Popups v-if="showPopup" :isSection="false" @close="popupOrderClose" />
    <MobileMenu @close="menuClose" @order="popupOrderShow" />
  </header>
</template>
<script>
import $ from 'jquery';
import MobileMenu from './MobileMenu.vue'
import Popups from "./Popups.vue";

export default {
  components: {
    Popups,
    MobileMenu,
  },
  data() {
    return {
      point: (() => {
        var currentPoint;
        return {
          scr: function(c) {
            return currentPoint = $(c).scrollTop();
          },
          point: function() {
            return currentPoint;
          }
        }
      })(),
      closeFlag: false,
    }
  },
  computed: {
    showPopup() {
      return this.$store.state.showPopup;
    },
  },
  mounted() {
    var top = $(window).scrollTop();
    var $header = $('.header');
    var h = $header.outerHeight(true);

    $(window).on('scroll', function() {
      var currentTop = $(window).scrollTop()

      if (currentTop > top && !this.closeFlag) {
        $header.css("top", -h + "px");
      } else {
        $header.css("top", 0 + "px");
      }

      top = currentTop;
    });

    $(function() { // <<<--- sticky header
      var lastScrollTop = 0,
        delta = 100;
      $(window).scroll(function() {
        var nowScrollTop = $(this).scrollTop();
        if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
          if (nowScrollTop > lastScrollTop) {
            $('.header').removeClass('fixed');
            $('.header').addClass('scrolling');
          } else {
            $('.header').addClass('fixed');
          }
          lastScrollTop = nowScrollTop;
        }
      });
    });

    // $(window).scroll(function() {
    //   if ($(window).scrollTop() > 1) {
    //     $(".header-sticky-home").addClass('active-sticky-home');
    //     $('.logo-text').addClass('small-logo');
    //   } else {
    //     $('.header').css('margin-top', window.scrollY + 'px');
    //     $(".header-sticky-home").removeClass('active-sticky-home');
    //     $('.logo-text').removeClass('small-logo');
    //   }
    // });
  },
  methods: {
    disableTouch: function(e) {
      var popup = e.target.closest('.popup');
      var menuContainer = e.target.closest('.mobile-menu');
      if (menuContainer || popup) {
        return false;
      }
      e.preventDefault();
    },
    popupOrderShow() {
      this.menuClose();
      this.$store.commit('setDataProp', { showPopup: true });
    },
    popupOrderClose() {
      this.$store.commit('setDataProp', { showPopup: false });
    },
    menuOpen(e) {
      $('body').addClass("m-show");
      this.point.scr(window);
      //bug adaptive mobile
      setTimeout(function() {
        $('body').addClass('fix');
      }, 450)

      // $('body').addClass('fix');
      e.stopPropagation();
      document.addEventListener('touchmove', this.disableTouch, { passive: false });
    },
    menuClose() {
      $('body').removeClass('fix');
      $('html, body').animate({ scrollTop: this.point.point() }, 0, function() {});
      this.closeFlag = true;
      setTimeout(function() {
        $('body').removeClass("m-show");
        document.removeEventListener('touchmove', this.disableTouch, { passive: false });
      }, 150)
      $('body').removeClass("m-show");
      document.removeEventListener('touchmove', this.disableTouch, { passive: false });
      setTimeout(function() {
        this.closeFlag = false
      }, 450);
    },
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 34px 0 35px;
  background: white;
  position: -webkit-sticky;
  position: sticky;
  top: 0 !important;
  margin-top: 0;
  z-index: 999999;
}

.header-inner.mob {
  display: none;
}

.header__logo {
  display: inline-block;
  vertical-align: top;
}

.header__phone {
  display: inline-block;
  vertical-align: top;
  font-size: 16px;
  line-height: 23px;
  font-family: "Graphik-Medium-Cy", sans-serif;
}

.header__col {
  display: -ms-flexbox;
  display: flex;
}

.header_scrolled {
  padding: 12px 0;
}

.header-inner {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: center;
  align-items: center;
}

.main-nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  margin-top: 15px;
}

.main-nav__item {
  display: inline-block;
  vertical-align: top;
  margin: 0 9px;
  font-size: 14px;
  line-height: 25px;
  border-bottom: 2px solid rgba(0, 0, 0, 0);
}

.main-nav__item_active {
  border-bottom-color: #78b301;
}

.logo-text {
  font-size: 30px;
  margin-top: 5px;
  margin-right: 108px;
}

.logo-text-pink {
  font-family: Graphik-Medium-Cy;
  font-weight: 1000;
  color: #78b301;
}

.active-sticky-home {
  padding: 4px 0 5px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
}

.small-logo {
  font-size: 24px;
  margin-top: 12px;
  margin-right: 70px;
  transition: .35s ease-in-out;
}


/* Mobile header */
.burger {
  margin: 22px 20px 18px;
}

/* Adaptive */
@media screen and (max-width: 767px) {
  .header {
    width: 100%;
    background: black;
    padding: 0;
    margin-top: -60px;
    &.scrolling {
      margin-top: -100px;
    }
    &.fixed {
      position: fixed;
      margin-top: 0;
      transition: margin-top .5s ease;
    }
  }

  .header-inner {
    display: none;
  }

  .header-inner.mob {
    display: flex;
  }

  .a {
    fill: #fff;
    display: block;
    width: 18px;
  }

  .logo-text {
    font-size: 21px;
    margin: 0 0 0 20px;
    color: #FFF;
  }
}
</style>